import { render } from "./psiShop.vue?vue&type=template&id=45e2772a"
import script from "./psiShop.vue?vue&type=script&lang=jsx"
export * from "./psiShop.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__